import { useCallback, useEffect, useState } from 'react';

import { aegisApi } from 'api/aegis';
import { useAuth } from 'contexts/AuthContext';

export default function usePlatformAdminAccess() {
  const { isAuthenticated } = useAuth();
  const [platformAdmin, setPlatformAdmin] = useState(null);
  const [status, setStatus] = useState(isAuthenticated ? 'loading' : 'unauthenticated');
  const [message, setMessage] = useState(null);

  const refreshPlatformAdmin = useCallback(async () => {
    if (!isAuthenticated) {
      setPlatformAdmin(null);
      setStatus('unauthenticated');
      setMessage(null);
      return null;
    }

    setStatus('loading');
    setMessage(null);
    try {
      const admin = await aegisApi.platformMe();
      setPlatformAdmin(admin);
      setStatus('allowed');
      return admin;
    } catch (error) {
      setPlatformAdmin(null);
      setStatus('denied');
      setMessage(error.message);
      return null;
    }
  }, [isAuthenticated]);

  useEffect(() => {
    refreshPlatformAdmin();
  }, [refreshPlatformAdmin]);

  return {
    hasPlatformAccess: status === 'allowed',
    message,
    platformAdmin,
    refreshPlatformAdmin,
    status
  };
}
